/**
 * HelpfulTips Styled Components
 * Extracted from HelpfulTips for better separation of concerns
 */

import { Box, Text, styled } from '@ltvco/refresh-lib/theme';

export const TipsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.common.white,
  borderRadius: '20px',
  border: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2.5, 2),
    borderRadius: '12px',
  },
}));

export const TipsGrid = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'flex-start',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(6.5),
  },
}));

export const TipCard = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
  minWidth: 0,
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const TipIconContainer = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  width: '100px',
  height: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  [theme.breakpoints.down('sm')]: {
    width: '80px',
    height: '80px',
  },
}));

export const TipContent = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '11px',
  justifyContent: 'center',
  minWidth: 0,
}));

export const TipTitle = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '0.875rem',
  lineHeight: '16px',
  color: theme.palette.text.primary,
}));

export const TipDescription = styled(Text)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '0.875rem',
  lineHeight: '16px',
  color: theme.palette.text.secondary,
}));

export const SectionTitle = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1rem',
  lineHeight: '24px',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2.5),
}));
